"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CardNotificationPanel = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _AppPanel = require("@uifabric/portal-ux/lib/AppPanel");

var _FocusZone = require("@fluentui/react/lib/FocusZone");

var _List = require("@fluentui/react/lib/List");

var _Panel = require("@fluentui/react/lib/Panel");

var _withResponsiveMode = require("@fluentui/react/lib/utilities/decorators/withResponsiveMode");

var React = _interopRequireWildcard(require("react"));

var _CardNotification = require("../CardNotification/CardNotification");

var _class, _temp;

var ROWS_PER_PAGE = 10;
var MAX_CELL_WIDTH = 288;
/**
 * Represents a list of Notifications that display in the Notification Panel.
 */

var CardNotificationPanel = (0, _withResponsiveMode.withResponsiveMode)(_class = (_temp = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CardNotificationPanel, _React$Component);

  var _super = (0, _createSuper2.default)(CardNotificationPanel);

  function CardNotificationPanel() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, CardNotificationPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this._columnCount = 0;

    _this._getItemCountForPage = function (itemIndex, visibleRect) {
      if (itemIndex === 0 && visibleRect !== undefined) {
        _this._columnCount = Math.floor(visibleRect.width / MAX_CELL_WIDTH);
      }

      return _this._columnCount * ROWS_PER_PAGE;
    };

    _this._onRenderCell = function (notification) {
      if (!notification) {
        return null;
      }

      var localizableMessage = notification && notification.localizableMessage;
      var localizableTitle = notification && notification.localizableTitle;
      var primaryAction = notification && notification.primaryAction;
      var secondaryAction = notification && notification.secondaryAction;
      var tertiaryAction = notification && notification.tertiaryAction;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardNotification.CardNotification, {
        t: _this.props.t,
        id: notification.id,
        createdDateTime: notification.createdDateTime,
        localizableTitle: localizableTitle,
        localizableMessage: localizableMessage,
        severity: notification.severity,
        type: notification.type,
        primaryAction: primaryAction,
        secondaryAction: secondaryAction,
        tertiaryAction: tertiaryAction,
        correlationId: notification.correlationId,
        raiseAction: _this.props.raiseAction
      });
    };

    return _this;
  }

  (0, _createClass2.default)(CardNotificationPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          notifications = _this$props.notifications;
      var notificationsCopy = notifications ? (0, _toConsumableArray2.default)(notifications) : null;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppPanel.AppPanel, {
        isOpen: this.props.isOpen,
        type: _Panel.PanelType.smallFixedFar,
        onDismiss: this.props.onDismiss,
        headerText: t('Notifications') + ' ' + (notificationsCopy ? '(' + notificationsCopy.length + ')' : ''),
        closeButtonAriaLabel: t('Close'),
        isContentFullBleed: notificationsCopy ? true : false,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusZone.FocusZone, {
          children: notificationsCopy ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
            items: notificationsCopy,
            onRenderCell: this._onRenderCell,
            getItemCountForPage: this._getItemCountForPage
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: this.props.t("Looks like you don't have any notifications yet.")
          })
        })
      });
    }
  }]);
  return CardNotificationPanel;
}(React.Component), _temp)) || _class;

exports.CardNotificationPanel = CardNotificationPanel;